import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../../../../store/actions';
import UploadModal from './UploadModal';

const mapStateToProps = state => ({
    library: state.library,
    topics: state.topics,
    user: state.user
});

const mapDispatchToProps = dispatch => bindActionCreators({
    upload: actions.library.upload,
    clearUploadList: actions.library.clearUploadList,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadModal);